// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2L69T","column":"style_column__xlnqk","row":"style_row__15OLl"};